import type { IconSvgObject } from './types';

const TextTrackingIcon: IconSvgObject = [
  ["path", { d: "M20 17L22 19L20 21M4 17L2 19L4 21M2.52474 19H21.2899", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 14L18 3H17L13 14M14.4545 10H20.5455", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 3L6.5 14L2 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TextTrackingIcon;
